export enum FileType {
    FILE = 0,
    VIDEO = 1,
    IMAGE = 2
}